import React from "react";

const SectionHeading = ({ overline, title, subtitle, align = "left" }) => {
  const alignClass = align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <div className={`flex flex-col ${alignClass} max-w-3xl ${align === "center" ? "mx-auto" : ""}`}>
      {overline && <span className="text-overline mb-5">{overline}</span>}
      <h2 className="font-display font-light text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight text-white">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-5 text-white/65 text-base md:text-lg leading-relaxed max-w-2xl">{subtitle}</p>
      )}
    </div>
  );
};

export default SectionHeading;
